'use client'

import dynamic from 'next/dynamic'

/**
 * Lazy handle for the cookie banner.
 *
 * The split has to happen in a client module rather than in the root layout.
 * Calling `next/dynamic` on a client component from a Server Component produces
 * "client reference proxy" errors during App Shell validation on every route —
 * the build passes, but the shell fails to validate at runtime. execheadshots-app
 * hit exactly this and moved the split into its own client module; see
 * `components/cookies/cookie-consent-lazy.tsx` there.
 *
 * From a Client Component the split is well-defined and `ssr: false` is
 * available, which is what we want anyway: the banner renders nothing until its
 * own `requestIdleCallback` check decides whether to show it, so server-rendering
 * it was never buying anything. Keeps `vanilla-cookieconsent`'s JS *and* its CSS
 * out of first load on every route.
 */
export const CookieConsentLazy = dynamic(
  () => import('./cookie-consent').then((m) => m.CookieConsent),
  { ssr: false },
)
